<template>
  <v-col>
    <v-window v-model="step">
      <v-window-item :value="1">
        <v-row>
          <v-col cols="12">
            <div class="subtitle-2">What is the company name?</div>
            <v-text-field
              v-model="formData.company_name"
              label="Company Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <AddressAutocomplete
              :value="usfAddress"
              @registerAddressChange="setAddress($event)"
            />
          </v-col>
        </v-row>
      </v-window-item>

      <v-window-item :value="2">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <div class="subtitle-2">Which account is exempt?</div>
            <v-text-field
              v-model="formData.exempt_account"
              label="Exempt Account"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <div class="subtitle-2">What is the FCC 499 Filer ID?</div>
            <v-text-field
              v-model="formData.filer_id"
              label="FCC 499 Filer ID"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-window-item>

      <v-window-item :value="3">
        <v-row>
          <v-col>
            <v-radio-group v-model="formData.has_usf_upload">
              <template v-slot:label>
                <div>
                  Do you have a copy of your
                  <strong
                    >Annual Universal Service Charge Exemption
                    Certificate</strong
                  >
                  to upload?
                </div>
              </template>
              <v-radio value="yes">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
              <v-radio value="no">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>
            <Upload v-if="formData.has_usf_upload == 'yes'" />
          </v-col>
        </v-row>
      </v-window-item>
      <v-window-item :value="4">
        <v-row>
          <v-col cols="12">
            <v-radio-group v-model="formData.services_exempt">
              <div class="subtitle-2 pb-3">
                Services Exempt (please check all that apply):
              </div>
              <v-radio value="y">
                <template v-slot:label>
                  <div>All International / Interstate Long Distance Usage</div>
                </template>
              </v-radio>
              <v-radio value="n">
                <template v-slot:label>
                  <div>
                    Listed* International / Interstate Private Line Circuits
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
            <div v-if="formData.services_exempt === 'n'">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Product</th>
                      <th class="text-left">USF Exempt</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="product in products"
                      :key="product.product_id"
                    >
                      <td>{{ product.product_name }}</td>
                      <td>
                        <v-radio-group
                          v-model="product.usf_exempt"
                          @change="registerProductChange(product)"
                        >
                          <v-radio value="y" label="Yes" />
                          <v-radio value="n" label="No" />
                        </v-radio-group>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>
        </v-row>
      </v-window-item>
    </v-window>
  </v-col>
</template>

<script>
import AddressAutocomplete from "@/components/formfields/AddressAutocomplete.vue";
import Upload from "@/components/subforms/Upload.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ExemptionForm",
  components: {
    AddressAutocomplete,
    Upload,
  },
  data() {
    return {
      step: 1,
      upload: false,
      formData: {},
      products: [],
    };
  },
  mounted() {
    const vm = this;
    const generalData = this.getFormData.general;
    this.$set(this.formData, 'has_usf_upload', generalData.has_usf_upload);
    this.$set(this.formData, 'company_name', generalData.company_name);
    this.$set(this.formData, 'exempt_account', generalData.exempt_account);
    this.$set(this.formData, 'filer_id', generalData.filer_id);
    this.$set(this.formData, 'services_exempt', generalData.services_exempt);
    this.$set(this.formData, 'usf_address', generalData.usf_address);
    this.$set(this.formData, 'usf_suite', generalData.usf_suite);
    this.$set(this.formData, 'usf_city', generalData.usf_city);
    this.$set(this.formData, 'usf_state', generalData.usf_state);
    this.$set(this.formData, 'usf_zip', generalData.usf_zip);

    this.getProducts.forEach((product) => {
      if (product.is_voice) {
        this.products.push({
          product_name: product.product_name,
          usf_exempt: this.getFormData[`${product.product_id}`].is_usf_exempt,
          product_id: product.product_id,
        });
      }
    });
    if (!this.review) {
      this.hijackStepper((goRight) => {
        if ((vm.step === 1 && !goRight) || (vm.step === 4 && goRight)) {
          vm.unHijackStepper();
          vm.nextSubTab(goRight);
        }
        vm.step += goRight ? 1 : -1;
      });
    }
  },
  beforeDestroy() {
    this.unHijackStepper();
  },
  methods: {
    ...mapActions([
      "updateStoreFormData",
      "hijackStepper",
      "unHijackStepper",
      "nextSubTab",
    ]),
    setAddress(newAddress) {
      this.$set(this.formData, 'usf_address', newAddress.streetAddress);
      this.$set(this.formData, 'usf_city', newAddress.suite);
      this.$set(this.formData, 'usf_city', newAddress.city);
      this.$set(this.formData, 'usf_state', newAddress.state);
      this.$set(this.formData, 'usf_zip', newAddress.zip);
    },
    registerFormChange(val) {
      const keys = Object.keys(val);
      keys.forEach((key) => {
        this.updateStoreFormData({
          data: val[key],
          main: 'general',
          sub: key,
        });
      });
    },
    registerProductChange(product) {
      this.updateStoreFormData({
        data: product.usf_exempt,
        main: product.product_id,
        sub: "is_usf_exempt",
      });
    },
  },
  computed: {
    ...mapGetters(["getFormData", "getProducts"]),
    usfAddress() {
      const address = {};
      if (this.formData.usf_address) {
        // Use saved data if it exists
        address.streetAddress = this.formData.usf_address;
        address.suite = this.formData.usf_suite;
        address.city = this.formData.usf_city;
        address.state = this.formData.usf_state;
        address.zip = this.formData.usf_zip;
      }
      return address;
    },
  },
  watch: {
    formData: {
      handler(val) {
        this.registerFormChange(val);
      },
      deep: true,
    },
  },
};
</script>
